export default "__VITE_ASSET__DC24OoBQ__"